import styled from "styled-components";
import colors from "../../../../../utils/colors";

const StyledError = styled.div`
  font-size: 0.875rem;
  color: ${colors.BRAND_RED_DARK};
  border-radius: 0.3125rem;
  padding: 0.275rem 0.625rem;
  box-sizing: border-box;
  line-height: 1rem;
`;

export default StyledError;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledError.js